export const initialState = {
  token: null,
  codeCourse: null,
  loadingAuth: false,
  isErrorAuth: false,
  errorAuthMessage: '',
}